import { useForm } from "react-hook-form";

import { GenericLandingCard, RegisterForm } from "components";
import { useAppSelector } from "store/store";
import { GenericBackToBtn, RegisterBtn } from "components/buttons";
import { buttonBack } from "../_constants";

export const RegisterPage = () => {
  const registerForm = useAppSelector((state) => state.registerFormSlice.value);
  const { control, trigger, handleSubmit } = useForm({
    mode: "onChange",
    defaultValues: registerForm,
  });

  return (
    <GenericLandingCard
      rightColumn={
        <RegisterForm
          control={control}
          handleSubmit={handleSubmit}
          trigger={trigger}
        />
      }
      leftInteraction={<GenericBackToBtn label={buttonBack} link="/" />}
      rightInteraction={<RegisterBtn />}
    ></GenericLandingCard>
  );
};
